import { useMutation } from "@tanstack/react-query";
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { DeleteSavedList } from "../../api/api";

// The shape of the API’s response
type DeleteListResult = {
  status: string;
  msg?: string;
  errorCode?: string;
};

// What the hook’s caller will pass in
type DeleteListPayload = {
  filterType: string;
  filterListName: string;
};

export const usePostDeleteList = () => {
  const { getAccessTokenSilently } = useAuth0();

  const mutation = useMutation<
    DeleteListResult, // data returned
    unknown, // error
    DeleteListPayload & { token: string } // variables passed to mutationFn
  >({
    mutationFn: async ({
      filterType,
      filterListName,
      token,
    }) => {
      return DeleteSavedList(
        { filterType, filterListName },
        token
      );
    },

    onSuccess: (data) => {
      // Can handle success globally here, e.g., show a toast
    },
    onError: (error) => {
      // Can handle/report errors globally here
    },
  });

  const mutate = useCallback(
    async (
      payload: DeleteListPayload,
      options?: {
        onSuccess?: (data: DeleteListResult) => void;
        onError?: (error: unknown) => void;
        onSettled?: () => void;
      }
    ) => {
      const token = await getAccessTokenSilently();
      return mutation.mutateAsync(
        { ...payload, token },
        options
      );
    },
    [getAccessTokenSilently, mutation]
  );

  return { ...mutation, mutate };
};
